/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';

const $root =
  $protobuf.roots['default'] ||
  ($protobuf.roots['default'] = new $protobuf.Root());

const jsonData = {
  squareup: {
    nested: {
      sub2: {
        nested: {
          data: {
            nested: {
              UsageUnitType: {
                values: {
                  INVALID: 0,
                  EMPLOYEE: 1,
                  RETAIL_DEVICE: 2,
                  CUSTOMER: 3,
                  APPOINTMENTS_EMPLOYEE: 4,
                  RESTAURANTS_LOCATION: 5,
                  RESTAURANTS_ADDITIONAL_DEVICE: 6,
                  RETAIL_LOCATION: 7,
                  RETAIL_ADDITIONAL_DEVICE: 8,
                  EMPLOYEE_MANAGEMENT_LOCATION: 9,
                  SPOS_DEVICE_SETTINGS_DEVICE: 10,
                  REACHABLE_CONTACTS: 11,
                  LOYALTY_LOCATIONS: 12,
                  LOYALTY_TRANSACTIONS: 13,
                  LOYALTY_TRANSACTIONS_TIER: 14,
                  PAYROLL_EMPLOYEE: 15,
                  PAYROLL_W2_EMPLOYER: 16,
                  MARKETING_SMS_MESSAGES: 17,
                  LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_1: 18,
                  LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_2: 19,
                  LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_3: 20,
                  KDS_DEVICE: 21,
                  APPOINTMENTS_LOCATIONS: 22,
                  RESTAURANTS_MOBILE_LOCATION: 23,
                  SHIFTS_TEAM_MEMBER: 24,
                  ECOM_SITES: 25,
                  ECOM_ACCOUNT: 26,
                  MARKETING_MMS_MESSAGES: 27,
                  COMMS_TEAM_MEMBER: 28,
                  MESSAGES_LOCATION: 29,
                  HR_TOOLKIT_EMPLOYEE: 30,
                  HR_MANAGER_EMPLOYEE: 31,
                  STAFF_TEAM_MEMBER: 32,
                  HR_MANAGER_TEAM_MEMBER: 33,
                  PAYROLL_MAILED_TAX_FORM: 34,
                  STAFF_LOCATION: 35,
                  FNB_KIOSK_DEVICE: 36,
                  COMBOS_LOCATION: 37,
                  FRANCHISE_LOCATION: 38,
                  RESTAURANTS_MOBILE_DEVICE: 39,
                  LOYALTY_PAYG_USAGE: 40,
                  LOYALTY_PAYG_LOCATION: 41,
                  BILLABLE_LOCATION: 42,
                  HARDWARE_RENTAL_T2_DEVICE: 43,
                  HARDWARE_RENTAL_T3_DEVICE: 44,
                },
              },
            },
          },
        },
      },
    },
  },
};

// Do not initialize these protos if they have already been defined
if (
  !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.UsageUnitType
) {
  $root.addJSON(jsonData);
}

/**
 * The type of unit for usage/pricing. For example, employee, register device, etc.
 *
 * SOURCE UsageUnitType @ squareup/sub2/data.proto at 766:1
 */
export const UsageUnitType = $root.lookupEnum(
  'squareup.sub2.data.UsageUnitType'
).values;
